// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1yvjB","loader":"style_loader__1Nhke","ring":"style_ring__1vS4v"};